import { Injectable, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SettingsService } from '../../settings';

interface Setting {
  key: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {

  private _settings = signal<{ [key: string]: string }>({});
  readonly settings = this._settings.asReadonly();

  private _isLoaded = signal(false);
  readonly isLoaded = this._isLoaded.asReadonly();

  private _isInitialized = signal(false);
  readonly isInitialized = this._isInitialized.asReadonly();

  constructor(private http: HttpClient,  protected settingService: SettingsService, ) {}

  async loadSettings(): Promise<void> {
      let url = this.settingService.getSettings().baseUrl;
      let v = this.settingService.getSettings().apiVersion;
 
    this._isInitialized.set(true);

    if (this._isLoaded()) return; // prevent double-fetch
    const data : any = await firstValueFrom(this.http.get(`${url}/lightstone-partysettings-api/${v}/settings/get`));
    const mapped: { [key: string]: string } = {};

    if(data && data.data)
    {
      data.data.forEach((item: any) => {
        if (item.key && item.value) {
           mapped[item.key] = item.value;
        }
      });
    }
 
    this._settings.set(mapped);
    this._isLoaded.set(true);
  }

  getValue(key: string): string | undefined {
    return this._settings()[key];
  }

  setItem(key: string, value: string): void {
    if (this._settings()[key] !== value) {
      this._settings.update((current) => ({ ...current, [key]: value }));
    }

      let url = this.settingService.getSettings().baseUrl;
      let v = this.settingService.getSettings().apiVersion;
    const setting: Setting = { key, value };
    firstValueFrom(this.http.post(`${url}/lightstone-partysettings-api/${v}/settings/set`, setting))
  }


  getItem(key: string) {
    return computed(() => this._settings()[key]);
  }
}